<div class="w-full bg-blue-400 overflow-hidden bg-gradient-to-b from-blue-400 via-blue-500 to-blue-600 inset-0 z-0">
    <!-- Wave SVG
    <svg class="absolute bottom-[-50px] left-0 w-full h-[300px] sm:h-[200px] md:h-[300px] z-10" viewBox="0 0 1440 320"
        preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"> -->

    <svg class="absolute top-[1px] left-0 w-full h-80 z-0 border-opacity-0 bg-gradient-to-b from-blue-400"
        viewBox="0 0 1440 320" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <!-- Wave Layer 1 -->
        <path class="wave" fill="#ffffff" fill-opacity="0.7"
            d="M0,128L48,112C96,96,192,64,288,53.3C384,43,480,53,576,72C672,91,768,117,864,128C960,139,1056,133,1152,117.3C1248,101,1344,75,1392,61.3L1440,48L1440,320L0,320Z">
            <animate attributeName="d" dur="15s" repeatCount="indefinite"
                values="
                M0,128L48,112C96,96,192,64,288,53.3C384,43,480,53,576,72C672,91,768,117,864,128C960,139,1056,133,1152,117.3C1248,101,1344,75,1392,61.3L1440,48L1440,320L0,320Z;
                M0,112L48,96C96,80,192,48,288,45.3C384,43,480,69,576,80C672,91,768,85,864,96C960,107,1056,122,1152,109.3C1248,96,1344,69,1392,56.3L1440,48L1440,320L0,320Z;
                M0,128L48,112C96,96,192,64,288,53.3C384,43,480,53,576,72C672,91,768,117,864,128C960,139,1056,133,1152,117.3C1248,101,1344,75,1392,61.3L1440,48L1440,320L0,320Z" />
        </path>
        <!-- Wave Layer 2 -->
        <path class="wave" fill="#ffffff" fill-opacity="0.4"
            d="M0,144L48,128C96,112,192,80,288,69.3C384,59,480,69,576,77.3C672,85,768,91,864,101.3C960,112,1056,128,1152,122.7C1248,117,1344,91,1392,77.3L1440,64L1440,320L0,320Z">
            <animate attributeName="d" dur="20s" repeatCount="indefinite"
                values="
                M0,144L48,128C96,112,192,80,288,69.3C384,59,480,69,576,77.3C672,85,768,91,864,101.3C960,112,1056,128,1152,122.7C1248,117,1344,91,1392,77.3L1440,64L1440,320L0,320Z;
                M0,128L48,112C96,96,192,64,288,61.3C384,59,480,85,576,90.7C672,96,768,80,864,85.3C960,91,1056,117,1152,114.7C1248,112,1344,85,1392,72L1440,59L1440,320L0,320Z;
                M0,144L48,128C96,112,192,80,288,69.3C384,59,480,69,576,77.3C672,85,768,91,864,101.3C960,112,1056,128,1152,122.7C1248,117,1344,91,1392,77.3L1440,64L1440,320L0,320Z" />
        </path>


        <!-- Wave Layer 3 -->
        <path fill="#ffffff" fill-opacity="0.25"
            d="M0,240L48,226.7C96,213,192,187,288,181.3C384,176,480,192,576,202.7C672,213,768,219,864,218.7C960,219,1056,213,1152,208C1248,203,1344,197,1392,192L1440,187L1440,320L0,320Z">
            <animate attributeName="d" dur="25s" repeatCount="indefinite"
                values="
          M0,240L48,226.7C96,213,192,187,288,181.3C384,176,480,192,576,202.7C672,213,768,219,864,218.7C960,219,1056,213,1152,208C1248,203,1344,197,1392,192L1440,187L1440,320L0,320Z;
          M0,224L48,210.7C96,197,192,171,288,165.3C384,160,480,176,576,186.7C672,197,768,203,864,202.7C960,203,1056,197,1152,192C1248,187,1344,181,1392,176L1440,171L1440,320L0,320Z;
          M0,240L48,226.7C96,213,192,187,288,181.3C384,176,480,192,576,202.7C672,213,768,219,864,218.7C960,219,1056,213,1152,208C1248,203,1344,197,1392,192L1440,187L1440,320L0,320Z" />
        </path>
    </svg>

    <!-- Blue Background Above the Wave -->
    <!-- <div class="absolute inset-0 bg-blue-400  z-0"></div> -->
    <!-- <div class="absolute bg-gradient-to-b inset-0 z-0"></div> -->

    <!-- <div class="absolute bg-gradient-to-b from-blue-100 shadow-md transition-all inset-0 z-0"></div> -->

</div>